import { createContext } from "react"

const PosProductContext = createContext({})

export const PosProductProvider = PosProductContext.Provider
export const PosProductConsumer = PosProductContext.Consumer

export default PosProductContext
